import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

interface DeviceState {
    uuid: string | null;
}

const initialState: DeviceState = {
    uuid: null,
};

export const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        setUUID(state, action: PayloadAction<string>) {
            state.uuid = action.payload;
        },
        generateUUID(state) {
            if (!state.uuid) {
                state.uuid = uuidv4();
            }
        },
        clearUUID(state) {
            state.uuid = null;
        },
    },
});

export const { setUUID, generateUUID, clearUUID } = deviceSlice.actions;
export default deviceSlice.reducer;
